<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My package seems to have stopped moving</h1>

			<div v-if="condition !== 'marketplace'">
				<div class="h-email-form" v-if="loaded">
					<email-form
							subject="My package seems to have stopped moving"
							:body="mail_body"
							on-success-url="/help?#/submitted"
							edit-body
							:payload="{ order_line_id }"
							destination-key="cs"
					></email-form>
				</div>
			</div>
			<div v-else>
				<div class="h-email-form" v-if="loaded">
					<email-form
							subject="My marketplace item seems to have stopped moving"
							body="Can you refund me for this order?"
							on-success-url="/help?#/submitted"
							edit-body
							:payload="{ order_line_id }"
							destination-key="cs"
					></email-form>
				</div>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import EmailForm from './../../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "TrackingStoppedMoving",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				loaded: false,
				order_id: null,
				order_line_id: null,
				condition: null,
				isbn: null,
			}
		},

		computed: {
			mail_body() {
				return `I checked the tracking on my package and seems like it was lost in transit, can you please help me get my package?`;
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						let d = response['data']['data'];
						self.order_id = d['order_id'];
						self.order_line_id = parseInt(self.$route.params.id);
						self.isbn = d['book_isbn'];
						self.condition = d['product_type'];
						self.loaded = true;
					}
				})
				.finally(function () {
					self.loading = false;
				});
		}
	}
</script>

<style scoped>

</style>